// extracted by mini-css-extract-plugin
export default {"option":"Radio_option__uQaow","selected":"Radio_selected__pIigC"};